// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-radio-icon {
    height: 130px;
    width: 95px;
    padding-left: 5px;
    padding-right: 5px;
    left: 10px;
    font-size: 13px;
    font-weight: 300;
    text-align: center;
    vertical-align: text-bottom;
    cursor: pointer;
    margin-right: 15px;
    border: 1px solid rgb(70, 70, 70);
    border-radius: 2px;
    opacity: 0.8;
}

.form-radio-icon p {
    padding-top: 20px;
}

.form-radio-icon i {
    margin-top: 30px;
    font-size: 35px;
}

.form-radio-icon .titleForOwnerSVG {
    padding-top: 14px;

}

.form-radio-icon .titleForfreeAccomodationSVG {
    padding-top: 6px;

}

.form-radio-icon .ownerSGV {
    margin-top: 30px;
    height: 37px;
}

.form-radio-icon .freeAccomodationSVG {
    margin-top: 30px;
    height: 45px;
}

.form-radio-icon svg {
    margin-top: 30px;
    font-size: 35px;
}

.form-radio-icon .icon {
    margin-top: 30px;
    width: 60%;
    height: 35px;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.form-radio-icon input {
    display: none;
}

.form-radio-icon.selected {
    border-width: 1px;
    border-color: rgb(36, 146, 223);
    border-style: solid;
    border-radius: 2px;
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
    background: rgba(36,143,223,1);
    background: linear-gradient(135deg, rgba(36,143,223,1) 37%, rgba(37,175,227,1) 59%, rgba(40,234,234,1) 100%);
    color: white;
}

.form-radio-icon.selected .icon .st0 {
    fill: white;
}

.form-radio-icon.selected svg .st0 {
    fill: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/form/RadioIcon.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,+CAA+C;IAC/C,8BAA8B;IAC9B,4GAA4G;IAC5G,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":[".form-radio-icon {\n    height: 130px;\n    width: 95px;\n    padding-left: 5px;\n    padding-right: 5px;\n    left: 10px;\n    font-size: 13px;\n    font-weight: 300;\n    text-align: center;\n    vertical-align: text-bottom;\n    cursor: pointer;\n    margin-right: 15px;\n    border: 1px solid rgb(70, 70, 70);\n    border-radius: 2px;\n    opacity: 0.8;\n}\n\n.form-radio-icon p {\n    padding-top: 20px;\n}\n\n.form-radio-icon i {\n    margin-top: 30px;\n    font-size: 35px;\n}\n\n.form-radio-icon .titleForOwnerSVG {\n    padding-top: 14px;\n\n}\n\n.form-radio-icon .titleForfreeAccomodationSVG {\n    padding-top: 6px;\n\n}\n\n.form-radio-icon .ownerSGV {\n    margin-top: 30px;\n    height: 37px;\n}\n\n.form-radio-icon .freeAccomodationSVG {\n    margin-top: 30px;\n    height: 45px;\n}\n\n.form-radio-icon svg {\n    margin-top: 30px;\n    font-size: 35px;\n}\n\n.form-radio-icon .icon {\n    margin-top: 30px;\n    width: 60%;\n    height: 35px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.form-radio-icon input {\n    display: none;\n}\n\n.form-radio-icon.selected {\n    border-width: 1px;\n    border-color: rgb(36, 146, 223);\n    border-style: solid;\n    border-radius: 2px;\n    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);\n    background: rgba(36,143,223,1);\n    background: linear-gradient(135deg, rgba(36,143,223,1) 37%, rgba(37,175,227,1) 59%, rgba(40,234,234,1) 100%);\n    color: white;\n}\n\n.form-radio-icon.selected .icon .st0 {\n    fill: white;\n}\n\n.form-radio-icon.selected svg .st0 {\n    fill: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
